import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import Loading from '../components/Loading';
import React, {useEffect, useState} from 'react';
import axios from 'axios';
import HomeTitle from '../components/Home/HomeTitle';
import HomeNoShop from '../components/Home/HomeNoShop';
import HomeCardLink from '../components/Home/HomeCardLink';
import HomeQRButton from '../components/Home/HomeQRButton';
import HomeQRModal from '../components/Home/HomeQRModal';
import './HomePage.css';
import {Button, Col, Container, Row} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import {useConfig} from "../context/ConfigContext";
import {getShopIdFromToken, getUserRoleFromToken} from '../auth/authUtils';

export default function HomePage(){

    const navigate = useNavigate();
    const shopId = getShopIdFromToken();
    
    const [isFillShopBranchData, setIsFillShopBranchData] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [qr, setQr] = useState();

    const [shopBranch, setShopBranch] = useState();
    const [user, setUser] = useState();
    const [shopSubdomain, setShopSubdomain] = useState();

    // MODULOS DE CONFIGURACIONES DE NEGOCIO
    const { features } = useConfig();
    const userRole = getUserRoleFromToken();
    const reportesFeature = features.find(feature => feature.name === 'REPORTES');
    const expirationsProductFeature = features.find(feature => feature.name === 'VENCIMIENTOS DE PRODUCTOS');

    useEffect(() => {

        document.title = 'QReate';

        getUser();

        axios.get(process.env.REACT_APP_API_SHOP_BRANCH_ROUTE, {
            withCredentials: true
        })
        .then((response) => {
            setIsFillShopBranchData(true);
            setShopBranch(response.data);
        })
        .catch(() => {
            setIsFillShopBranchData(false)
        })
        .finally(() => {
            setIsLoading(false)
        });

        getShopBranches(shopId);

        // Verificar feature de vencimientos y obtener alertas temporales
        if (expirationsProductFeature && expirationsProductFeature.status) {
            axios.get(process.env.REACT_APP_API_TEMPORAL_ALERT_ROUTE, {
                withCredentials: true
            })
                .then((alertResponse) => {
                    alertResponse.data.forEach(alert => {
                        toast.warning(<div dangerouslySetInnerHTML={{ __html: alert.message }} />, {
                            position: "top-right",
                            autoClose: false,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            style: {
                                backgroundColor: 'rgb(223,78,78)',
                                color: 'white',
                                fontWeight: 'bold',
                            },
                        });
                    });
                })
                .catch((error) => {
                    console.error('Error al obtener alertas temporales:', error);
                });
        }

    }, []);

    const getUser = () => {
        axios.get(process.env.REACT_APP_API_USER_BY_USER_ROUTE, {
            withCredentials: true
        })
            .then((response) => {
                setUser(response.data);
            })
            .catch(() => {
            })
            .finally(() => {
                setIsLoading(false)
            });
    }

    const generateQR = () => {
        axios.get(process.env.REACT_APP_API_GENERATE_QR_ROUTE, {
            withCredentials: true,
            responseType: 'arraybuffer'
        })
        .then(response => {
            const blob = new Blob([response.data], { type: 'image/png' });
            const imageUrl = URL.createObjectURL(blob);
            // Decodificar la URL
            const decodedUrl = decodeURIComponent(imageUrl);
            setQr(decodedUrl);
        })
        .catch(error => {
            alertError();
            console.error(error)
        });
    }

    const getShopBranches = (shopId) => {
        axios.get(process.env.REACT_APP_API_SHOP_SUBDOMAIN_BYSHOPID_ROUTE, {
            params: {
                shopId: shopId
            }
        })
            .then(response => {
                setShopSubdomain(response.data);
            })
            .catch(error => {
                console.error(error);
            });
    }

    function alertError(){
        
        Swal.fire({
          title: 'Upsss',
          text: 'Ocurrió un error, vuelve a intentar',
          icon: 'error',
          timer: 1500,
          confirmButtonColor: 'rgb(246, 139, 127)',
          showConfirmButton: false,
        });

    }

    const download = () => {
        const url = qr;
        const a = document.createElement('a');
        a.href = url;
        a.download = 'qr_code.png';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    if (isLoading) {
        return <Loading/>; // Muestra un mensaje de carga mientras se realiza la petición
    }

    const handleRedirect = (url) => {
        navigate(url);
    }

    return (
      <Container fluid
                 style={{
                     display: 'flex',
                     flexDirection: 'column',
                     alignItems: 'center',
                     justifyContent: 'center',
                     minHeight: '100vh',
                 }}>
          {!isLoading && user && shopBranch && (
              <HomeTitle
                  shopBranchName={shopBranch.name}
                  nameUser={user.name}
                  lastnameUser={user.lastName}
                  username={user.username}
              />
          )}

          {!isFillShopBranchData ? (
          <HomeNoShop />
        ) : (
          <>
            <Container className='cardListContainer'>
              <HomeCardLink to={shopSubdomain?.url} title={'CARTA'} subtitle={'¡Aca podés ver tu carta lista!'} />
              <HomeQRButton action={generateQR} title={'QR'} subtitle={'Descargá el QR listo para usar'} />

                {reportesFeature && reportesFeature.status && userRole === 'ADMIN' ? (
                <Container className="mt-3" style={{ padding: '0px' }}>
                  <Row>
                    <Col className="cardReport">
                      <Button
                        style={{ height: '160px', width: '100%', borderRadius: '20px', fontWeight: 'bold' }}
                        onClick={() => handleRedirect('/reporteVentas')}
                      >
                        Reporte de ventas
                      </Button>
                    </Col>
                    <Col className="cardReport">
                      <Button
                        style={{ height: '160px', width: '100%', borderRadius: '20px', fontWeight: 'bold' }}
                        onClick={() => handleRedirect('/reporteProductos')}
                      >
                        Reporte de productos
                      </Button>
                    </Col>
                    <Col className="cardReport">
                      <Button
                        style={{ height: '160px', width: '100%', borderRadius: '20px', fontWeight: 'bold' }}
                        onClick={() => handleRedirect('/reporteCategorias')}
                      >
                        Reporte de categorías
                      </Button>
                    </Col>
                      <Col className="cardReport">
                          <Button
                              style={{ height: '160px', width: '100%', borderRadius: '20px', fontWeight: 'bold' }}
                              onClick={() => handleRedirect('/reporteMovimientos')}
                          >
                              Reporte de movimientos
                          </Button>
                      </Col>
                  </Row>
                </Container>
              ) : null}


            </Container>
          </>
        )}
        <HomeQRModal qr={qr} download={download} />
      </Container>
    );
}